import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Endpoint } from '@/Config/api/endpoint';
import { SocketKey } from '@/Config/api/socketKey';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { useSocket } from '@/Domain/components/SocketProvider';

type ConversationUpdatedEvent = {
  conversation: ConversationDto;
  conversation_id: string;
};

export const useConversationAssignee = (id: string) => {
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  useEffect(() => {
    const handler = (data: ConversationUpdatedEvent) => {
      const conversationId = data.conversation_id || data.conversation?.id;

      if (conversationId === id) {
        queryClient.setQueryData(
          [Endpoint.conversation.get, conversationId],
          (prevData: ConversationDto) => {
            if (prevData) {
              return {
                ...prevData,
                assignee: data.conversation?.assignee ?? prevData.assignee,
                // nullable field: fall back only when the payload is absent, not on an explicit null
                last_visitor_message_at: data.conversation
                  ? data.conversation.last_visitor_message_at
                  : prevData.last_visitor_message_at,
              };
            }

            return undefined;
          },
        );
      }
    };

    socket.on(SocketKey.conversation.conversationUpdated, handler);

    return () => {
      socket.off(SocketKey.conversation.conversationUpdated, handler);
    };
  }, [id, socket, queryClient]);
};
